import React, { useEffect, useState } from 'react'
import './style.css'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Typewriter from 'typewriter-effect'
import { introdata, blogdata, meta } from '../../content_option'
import { getAllPosts } from '../../utils/blogUtils'
import { Link } from 'react-router-dom'

export const Blog = () => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        let blogPosts = await getAllPosts()
        blogPosts = blogPosts.sort((a, b) => {
          const dateA = new Date(a.date)
          const dateB = new Date(b.date)
          return dateB - dateA
        })

        setPosts(blogPosts)
      } catch (error) {
        console.error('Failed to load blog posts:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchPosts()
  }, [])

  return (
    <HelmetProvider>
      <section id='blog' className='blog'>
        <Helmet>
          <meta charSet='utf-8' />
          <title> {meta.title} | Blog</title>
          <meta name='description' content={meta.description} />
        </Helmet>
        <div className='intro_sec d-block d-lg-flex align-items-center'>
          <div
            className='h_bg-image order-1 order-lg-2 h-100'
            style={{ backgroundImage: `url(${blogdata.img_url})` }}
          ></div>
          <div className='text order-2 order-lg-1 h-100 d-lg-flex justify-content-center'>
            <div className='intro mx-auto'>
              <Link to={'/'} className='title mb-1x'>
                {introdata.title}
              </Link>
              <div className='mb-1x'>
                <Typewriter
                  options={{
                    strings: [
                      blogdata.description.first,
                      blogdata.description.second,
                      blogdata.description.third,
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 10,
                  }}
                />
              </div>
              <div className='d-flex'>
                {loading ? (
                  <p>Loading posts...</p>
                ) : (
                  <ul className='list mb-1x'>
                    {posts.map((post) => (
                      <li key={post.slug}>
                        <Link
                          className='d-flex flex-column item mt-4'
                          to={`/blog/${post.slug}`}
                        >
                          <div className='post'>{post.title}</div>
                          <div className='date'>{post.date}</div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  )
}
